module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_13_1.bdaa125a.jpeg";